export class pagedList {
  'columnNames': string[]
  'pageIndex': number | undefined
  'totalPages': number | undefined
  'totalItems': number | undefined
  'items': any[]
  'hasPreviousPage': boolean | undefined
  'hasNextPage': boolean | undefined
}
